import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { ProductGridLoaderSwitchFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductGridLoaderSwitchFragmentFragmentDoc';

import type { InfiniteProductGridPageLoaderProps } from './InfiniteProductGrid.PageLoader';
import {
  CategoryPageInfiniteProductGridPageLoader,
  SearchResultPageInfiniteProductGridPageLoader,
} from './InfiniteProductGrid.PageLoader';
import { ensureExhaustiveCases } from '../../utils/ensureExhaustiveCases';

/* GraphQL */ `
  fragment ProductGridLoaderSwitchFragment on SearchProductResult {
    __typename
  }
`;

export type InfiniteProductGridPageLoaderSwitchProps = InfiniteProductGridPageLoaderProps & {
  maskedResult: FragmentType<typeof ProductGridLoaderSwitchFragmentFragmentDoc>;
};

export const InfiniteProductGridPageLoaderSwitch = ({
  maskedResult,
  ...dynamicProductGridProps
}: InfiniteProductGridPageLoaderSwitchProps) => {
  const result = unmask<typeof ProductGridLoaderSwitchFragmentFragmentDoc>(maskedResult);

  switch (result.__typename) {
    case 'SuccessfulSearchResult':
      return <SearchResultPageInfiniteProductGridPageLoader {...dynamicProductGridProps} />;
    case 'CategoryResult':
      return <CategoryPageInfiniteProductGridPageLoader {...dynamicProductGridProps} />;
    default:
      return ensureExhaustiveCases(result);
  }
};
